module.exports = __webpack_public_path__ + "5a1f3ff9c477abe5d29b06a68390cf5f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-s.png
// module id = 2179
// module chunks = 0